import * as state from '@/components/Analysis/state';
import { useAtomValue } from 'jotai';
import { SavedBlocksList } from './SavedBlocksList';
import { PaintBlocksList } from './PaintBlocksList';

export const CustomBlockList = () => {
  const isSavedBlocksSelected = useAtomValue(state.isSavedBlocksSelected);

  if (isSavedBlocksSelected) {
    return <SavedBlocksList />;
  }

  return <PaintBlocksList />;
};
